module.exports = __webpack_public_path__ + "assets/ad58d1540c913f3c76eee34683eeecf0.png";